import { reactive } from 'vue'

// The last API refusal that named a form field ({ error, field }); the EditForm whose save drew it rings that Field.
export const fieldError = reactive({ field: null, seq: 0 })

export const reportFieldError = (field) => {
  fieldError.field = field
  fieldError.seq++
}
